export default {
  install (Vue, options) {
    Vue.prototype.$notificacionSimpleConfirm = async function (titulo, mensaje) {
      return this.$bvModal.msgBoxConfirm(mensaje, {
        title: titulo,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'OK',
        cancelTitle: 'CANCEL',
        cancelVariant: 'primary',
        footerClass: 'p-2',
        hideHeaderClose: false,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        centered: true
      }).then((resp) => resp)
        .catch(() => 'error')
    }
    Vue.prototype.$notificacionSimple = async function (titulo, mensaje) {
      return this.$bvModal.msgBoxOk(mensaje, {
        title: titulo,
        size: 'sm',
        buttonSize: 'sm',
        /* ok */
        okClass: 'btn-primary',
        okTitle: 'OK',
        headerClass: 'border-bottom-0',
        footerClass: 'border-top-0',
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true
      }).then(() => 'success')
        .catch(() => 'error')
    }
  }
}
